import { useEffect, useState } from 'react';
import api from 'utils/api-services';
import { HeaderData, AffiliateData } from 'types';

const PREMIUM_SUBSCRIPTION_TYPE = 2;

const initialHeaderData: HeaderData = {
  abTests: [],
  canPurchaseReplyForFree: false,
  canReactivate: false,
  handle: '',
  isCompedUser: false,
  isLoggedIn: false,
  isPremiumSub: false,
  isSubscriber: false,
  primaryPhotoUri: '',
};

const initialAffiliateData: AffiliateData = {
  countryCode: 1,
  cultureCode: 'en-US', // TODO switch to constant once its added to arr
  siteCode: 1,
  urlCode: 1,
};

type SiteData = HeaderData &
  AffiliateData & {
    siteDataLoaded: boolean;
  };

export const initialSiteData: SiteData = {
  ...initialHeaderData,
  ...initialAffiliateData,
  siteDataLoaded: false,
};

const useSiteData = () => {
  const [headerData, setHeaderData] = useState(initialHeaderData);
  const [affiliateData, setAffiliateData] = useState(initialAffiliateData);
  const [headerDataLoaded, setHeaderDataLoaded] = useState(false);
  const [affiliateDataLoaded, setAffiliateDataLoaded] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    api.getHeaderData().then((res) => {
      const { abTests, subscriptionSummary, userFeatures, userSummary } = res;

      const isLoggedIn = userSummary && userSummary.userId;

      const isSubscriber = isLoggedIn && !!userFeatures && userFeatures.subscriber; // TODO UserFeatures won't be optional once the middleware update is published

      setHeaderData({
        abTests: abTests,
        canPurchaseReplyForFree: isLoggedIn && !!userFeatures && !userFeatures.replyForFree, // TODO UserFeatures won't be optional once the middleware update is published
        canReactivate: isLoggedIn && !subscriptionSummary.isAutoRenewActive && !isSubscriber,
        isCompedUser: isLoggedIn && subscriptionSummary.isComplimentary,
        isLoggedIn,
        isPremiumSub:
          (isLoggedIn && subscriptionSummary.subscriptionType === PREMIUM_SUBSCRIPTION_TYPE) ||
          false,
        isSubscriber,
        primaryPhotoUri: isLoggedIn && userSummary.primaryPhotoThumbnailUri,
        handle: isLoggedIn ? userSummary.handle : undefined,
      });

      setHeaderDataLoaded(true);
    });

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    api.getAffiliateData().then((res) => {
      setAffiliateData({
        urlCode: res.urlCode,
        siteCode: res.siteCode,
        cultureCode: res.cultureCode,
        countryCode: res.countryCode,
      });

      setAffiliateDataLoaded(true);
    });
  }, []);

  return {
    ...headerData,
    ...affiliateData,
    siteDataLoaded: headerDataLoaded && affiliateDataLoaded,
  };
};

export default useSiteData;
